<!-- Plugins -->

<div #thisBox class="fdm-plugin-box" [class.showwrap]="plugin.meta && !plugin.meta['hideWrapper']" [id]="'plugin-ui-'+ plugin.id" *ngIf="plugin" (click)="mouseclicks($event)">

    <!-- Plugin label and category -->
    <label *ngIf="plugin.meta && !plugin.meta['hideHeader']">
        {{ plugin.meta.label | translate }} <span class="fdm-tag-primary" id="category-plugin" *ngIf="plugin.meta">{{ plugin.meta.category | translate }}</span>
        
        <!-- Disable plugin -->
        <fa-icon *ngIf="!plugin['hideDelete'] && context" class="fdm-link fdm-text-large fdm-annotation-color-red" icon="trash" [matTooltip]="'PLUGIN.DISABLE'|translate" style="margin-left:20px;font-size:20px;" (click)="deletePlugin()" id="disable-plugin"></fa-icon>
        
        <!-- Configure plugin -->
        <fa-icon class="float-right fdm-link fdm-text-large fdm-annotation-color-blue" icon="cog" [matTooltip]="'PLUGIN.CONFIG'|translate" style="margin-right:8px;" *ngIf="plugin.has('configuration')" (click)="plugin.configure()" id="configure-plugin"></fa-icon>
        
        <!-- Restore plugin -->
        <fa-icon class="float-right fdm-link fdm-text-large fdm-annotation-color-blue" icon="file-upload" [matTooltip]="'PLUGIN.RESTORE'|translate" style="margin-right:8px;" *ngIf="plugin.hasBackupInItem()" (click)="plugin.restore()" id="restore-plugin"></fa-icon>
    </label>

    <mat-progress-bar color="accent" *ngIf="plugin.calculating" class="busy-progress" [mode]="plugin.calculateCurrent == 1 ? 'indeterminate' : 'buffer'" [value]="plugin.calculatePercent" [bufferValue]="plugin.calculatePercent" [matTooltip]="plugin.calculatePercent+'%'"></mat-progress-bar>

    <!-- <button *ngIf="!plugin['hideDelete'] && context" id="disable-plugin" style="margin:15px 1px;" mat-raised-button class="fdm-button" (click)="deletePlugin()">
        <fa-icon class="fdm-link" icon="times-circle"></fa-icon> {{ 'PLUGIN.DISABLE' | translate }} 
    </button> -->

    <!-- ({{ plugin.plugs }})  -->
    <div *ngIf="plugin.plugs && plugin.meta['plugsAsTabs']" class="plugin-box-tabs">
        <span (click)="currentTab = 'main'" class="fdm-linked" [class.selected]="currentTab == 'main'"> {{'PLUGINS.MAIN_TAB' | translate}} </span>
        <ng-container *ngFor="let p of plugin.plugs | keyvalue: originalOrder">
            <ng-container *ngIf="p.value && p.value.object">
                <span (click)="currentTab = p.value.object.id" class="fdm-linked" [class.selected]="currentTab == p.value.object.id"> 
                    {{ p.value?.object?.meta?.label | translate }} 
                    <fa-icon *ngIf="p.value.object.controls && p.value.object.controls['active'] && p.value.object.controls['active']['value']" icon="check-circle"></fa-icon>
                </span>
            </ng-container>
        </ng-container>
    </div>

    <!-- Show/hide plugins -->
    <div *ngIf="currentTab == 'main'" class="controls tabbed clearfix" [class.tabbed]="plugin.meta['plugsAsTabs']"><!-- [class.busy]="plugin.calculating" -->

        <ng-container *ngFor="let ctrl of plugin.controls | keyvalue: originalOrder">
            <ng-container *ngFor="let section of [ctrl.value]">
                <!-- <textarea style="width:100%;height:50px;font-size:7px;">{{ section | json }}</textarea> -->
                
                <label *ngIf="isFirstInGroup(ctrl)" class="fdm-group-label fdm-link" (click)="groups[section.group].show = !groups[section.group].show" style="display:block">
                    {{ (plugin.meta?.translator ? plugin.meta?.translator + "." + section.group : section.group) | translate }}
                    <span>
                        <fa-icon *ngIf="!groups[section.group].show" class="fdm-silent-icon" icon="caret-down"></fa-icon>
                        <fa-icon *ngIf="groups[section.group].show" class="fdm-silent-icon" icon="caret-up"></fa-icon>
                    </span>
                </label>

                <div *ngIf="!section['noshow']" [class]="checkGroups(ctrl) ? 'controller fdm-grouped fdm-grouped-' + getGroupIndex(ctrl) + ( groups[section.group].show ? '' : ' noshow' ) : 'controller' + ( isFirstNongroup(ctrl) ? ' fdm-group-end' : '')">
                    <!-- <textarea style="width:100%;height:200px;font-size:9px;">{{ ctrl.value | json }}</textarea> -->
                    <ng-container>

                        <div *ngIf="section.topSpace" style="border-bottom:dotted 1px #cccccc88;margin:11px 5px;"></div>

                        <label *ngIf="section.name && !section.nolabel">{{ section.name | translate }}</label>

                        <span class="content">
        
                            <ng-container *ngIf="section.type == 'compound' && section.items">
                                <ng-container *ngFor="let cc of section.items">
                                    <ng-container *ngIf="getReference(cc.reference)">
                                        <div class="controller" *ngIf="reference">
                                            <label *ngIf="reference.name">{{ reference.name }}</label>
                                            <span [class.content]="reference.name">
                                                <plugin-ui-section [plugin]="plugin" [item]="item" [section]="reference" [lastMouseEvent]="lastMouseEvent"></plugin-ui-section>
                                            </span>
                                        </div>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
        
                            <!-- <div class="custom-slider" *ngIf="ctrl.value.type == 'range'">
                                <ngx-slider style="width:230px;" [(value)]="ctrl.value.from" [(highValue)]="ctrl.value.to" [options]="{ floor:ctrl.value.min, ceil:ctrl.value.max, step:ctrl.value.step ? ctrl.value.step : 1 }"></ngx-slider>
                            </div>
                            <ng-container *ngIf="ctrl.value.type !== 'range'"> -->

                                <plugin-ui-section *ngIf="section.type !== 'compound'" [plugin]="plugin" [item]="item" [section]="section" [lastMouseEvent]="lastMouseEvent"></plugin-ui-section>
                            <!-- </ng-container> -->
                        
                        </span>
                    </ng-container>
                </div>
            </ng-container>
        </ng-container>
        
        <!-- Pulse feature -->
        <div class="controller" *ngIf="plugin.has('pulse')">
            <label>{{ 'PLUGIN.PULSE' | translate }} <fa-icon *ngIf="plugin.blip" icon="heartbeat" class="pulse" id="pulse-plugin" style="color:red;"></fa-icon> </label>
            <ng-container *ngIf="!plugin.pulsing">
                <input  type="number" style="width:30px;" [(ngModel)]="plugin.pulseSeconds" /> {{ 'PLUGIN.SEC' | translate }} 
                <fa-icon icon="play-circle" class="fdm-linked" (click)="plugin.startPulse();plugin.save();" ></fa-icon> 
            </ng-container>
            <fa-icon *ngIf="plugin.pulsing" icon="stop-circle" class="fdm-linked" (click)="plugin.stopPulse();plugin.save();"></fa-icon> 
        </div>
    </div>

    <div class="clearfix"></div>

    <ng-container *ngIf="plugin.plugs && plugin.meta['plugsAsTabs']">
        <ng-container *ngFor="let p of plugin.plugs | keyvalue: originalOrder">
            <ng-container *ngIf="p.value && p.value.object">
    
                <!-- tabbed -->
                <plugin-ui *ngIf="p.value.object && currentTab == p.value.object.id" [plugin]="p.value.object" [item]="plugin.item"></plugin-ui>
                
                <!-- Plugin popup -->
                <ng-container *ngIf="p.value.show">
                    <div *ngFor="let plug of [p.value.object]" class="fdm-plugin-popover" style="margin-left:50px;margin-top:-150px;" [id]="id+'pop'" [class.scale-up]="plug"> 
                        <fa-icon class="fdm-linked fdm-text-large float-right" icon="times-circle" (click)="p.value.show = false"></fa-icon>
                        <plugin-ui *ngIf="plug" [plugin]="plug" [item]="plugin.item"></plugin-ui>
                    </div>
                </ng-container>
    
            </ng-container>
        </ng-container>
    </ng-container>

</div>